"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApptSummaryContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ApptSummaryContainer = styled_1.default.div `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
//# sourceMappingURL=styles.js.map